const Constants = {
    PROJECTTITLE:"Foodsight dashboard",
// serverlink: 'http://localhost:3000/',
    serverlink: 'https://production.food-sight.com/',
    timeout: 40000
};

export default Constants;
